module.exports = __webpack_public_path__ + "static/media/divig.4756f4a4.svg";